export default __webpack_public_path__ + "static/media/20.69e584f6.png";